import Faq from "../../components/molecules/faq";
import Footer from "../../components/molecules/footer";
import Header from "../../components/molecules/header";
import Offers from "../../components/molecules/offers";
import Persuasions from "../../components/molecules/persuasions";
import Realizations from "../../components/molecules/realizations";
import SmartBanner from "../../components/molecules/smartBanner";
import StageTheme from "../../components/molecules/stageTheme";

function HomePage() {
  return (
    <>
      <SmartBanner />
      <Header />
      <main>
        <StageTheme />
        <Offers />
        <Realizations />
        <Persuasions />
        <Faq />
      </main>
      <Footer />
    </>
  );
}

export default HomePage;
